{
  "App": "Appli",
  "Profile": "Profil",
  "My Account": "Mon compte",
  "Contacts": "Contacts",
  "Preferences": "Préférences",
  "Family Language": "Langue de la famille",
  "Program Consent": "Consentement au programme",
  "Yes": "Oui",
  "No": "Non",
  "Not submitted": "Non envoyé",
  "See anything missing? Contact your Caring Adult": "Vous voyez quelque chose qui manque ? Contactez votre Adulte bienveillant",
  "Messages": "Messages",
  "Caring Adult for": "Adulte bienveillant pour",
  "Former Caring Adult for": "Ancien Adulte bienveillant pour",
  "Write your message here...": "Écrivez votre message ici...",
  "I need help with": "J’ai besoin d’aide en matière de",
  "Academic": "scolarité",
  "After School/ Out of School": "Activité parascolaire/en dehors de l’école",
  "Applying for benefits": "dépôt de demande d’avantages sociaux",
  "Childcare": "garde d’enfants",
  "Employment / Adult Education": "emploi/formation pour adultes",
  "Food": "nourriture",
  "Housing": "logement",
  "Legal services": "services juridiques",
  "Material Resources / Clothing / Laundry": "ressources matérielles/vêtements/lessive",
  "Mental/emotional health": "santé mentale/émotionnelle",
  "Physical health/asthma": "santé physique/asthme",
  "Transportation": "Transport",
  "Send": "Envoyer",
  "Today": "Aujourd’hui",
  "No messages yet": "Aucun message pour l’instant",
  "No messages": "Aucun message",
  "Start a conversation below": "Démarrez une conversation ci-dessous",
  "This Caring Adult is no longer available": "Cet Adulte bienveillant n’est plus disponible",
  "No longer available ": "N’est plus disponible ",
  "Monday": "Lundi",
  "Tuesday": "Mardi",
  "Wednesday": "Mercredi",
  "Thursday": "Jeudi",
  "Friday": "Vendredi",
  "Saturday": "Samedi",
  "Sunday": "Dimanche",
  "Emergency Contacts": "Personnes à contacter en cas d’urgence",
  "Supervisor of Social Workers for the Bronx": "Superviseur des travailleurs sociaux pour le Bronx",
  "Student Services Manager, High School District": "Responsable des services aux élèves, district scolaire secondaire",
  "Social Worker, Central Crisis Support Team": "Travailleur social, équipe centrale de soutien en cas de crise (Central Crisis Support Team)",
  "Support Line": "Ligne d’assistance",
  "Suicide and Crisis Lifeline": "Ligne d’assistance en cas de crise et pour la prévention des suicides (Suicide and Crisis Lifeline)",
  "Emergencies": "Urgences",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "Si vous faites face à une urgence mettant votre vie en danger et avez besoin d’une aide immédiate, appelez ou envoyez un SMS au 911",
  "About New Visions": "À propos de New Visions",
  "Privacy and Terms": "Confidentialité et conditions d’utilisation",
  "Homepage": "Page d’accueil",
  "Home Page": "Page d’accueil",
  "My family": "Ma famille",
  "Available Services": "Services disponibles",
  "Grade": "Niveau scolaire",
  "School": "École",
  "Attendance this year": "Présence cette année",
  "Absences last 5 days": "Absences au cours de cinq derniers jours",
  "Caring Adult": "Adulte bienveillant",
  "Message": "Message",
  "Not available": "Non disponible",
  "Not yet assigned": "Non encore attribué",
  "No absences": "Aucune absence",
  "Phone not available": "Numéro de téléphone non disponible",
  "Email address not available": "Adresse e-mail non disponible",
  "January": "Janvier",
  "February": "Février",
  "March": "Mars",
  "April": "Avril",
  "May": "Mai",
  "June": "Juin",
  "July": "Juillet",
  "August": "Août",
  "September": "Septembre",
  "October": "Octobre",
  "November": "Novembre",
  "December": "Décembre",
  "Sidenav": "Navigation latérale",
  "Home": "Accueil",
  "Log out": "Se déconnecter",
  "Accessibility": "Accessibilité",
  "Skip to main content": "Aller directement au contenu principal",
  "Email": "Adresse e-mail",
  "Phone": "Numéro de téléphone",
  "Family Portal": "Portail des familles",
  "Every Child and Family is Known": "Chaque enfant et chaque famille comptent",
  "Family Portal: Every Child and Family is Known": "Portail des familles : Chaque enfant et chaque famille comptent",
  "Close menu": "Fermer le menu",
  "Open menu": "Ouvrir le menu",
  "Notes": "Notes",
  "Send message": "Envoyer le message",
  "Languages": "Langues",
  "Consent status": "Statut du consentement",
  "Select": "Sélectionner",
  "Language selector": "Sélecteur de langue",
  "Sorry": "Désolé",
  "we couldn't find that page": "nous n'avons pas trouver cette page",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "Vous n'êtes pas encore autorisé à vous connecter au Portail Famille. Veuillez contacter votre adulte attentionné pour y accéder."
}
